<template>
  <div class="WebsiteShareUserSection">
    <p class="WebsiteShareUserSection__label">Share with specific people</p>

    <GptShareUserSearch
      class="WebsiteShareUserSection__search"
      :users="shareUsers"
      :usersWithAccess="usersWithAccess"
      @addUser="onAddUser"
      @removeUser="onRemoveUser"
    />
  </div>
</template>

<script lang="ts" setup>
import type { ISelectedUser } from '@/apiClient/types/user'
import GptShareUserSearch from '@/views/pages/Gpt/List/components/GptShareUserSearch.vue'

const props = defineProps<{
  shareUsers: ISelectedUser[]
  usersWithAccess: ISelectedUser[]
}>()

const emit = defineEmits<{
  'update:shareUsers': [users: ISelectedUser[]]
}>()

const getUserIdentity = (accessUser: ISelectedUser) =>
  accessUser.id || accessUser.employee_id || accessUser.email || accessUser.name

function onAddUser(accessUser: ISelectedUser) {
  if (
    props.shareUsers.some(
      (user) => getUserIdentity(user) === getUserIdentity(accessUser),
    )
  ) {
    return
  }
  emit('update:shareUsers', [...props.shareUsers, accessUser])
}

function onRemoveUser(accessUser: ISelectedUser) {
  emit(
    'update:shareUsers',
    props.shareUsers.filter(
      (user) => getUserIdentity(user) !== getUserIdentity(accessUser),
    ),
  )
}
</script>

<style scoped lang="scss">
.WebsiteShareUserSection {
  display: flex;
  flex-direction: column;
  gap: var(---fds-global-space-xs);

  // Same metrics as ui-lib's UIInputLabel, which renders the labels on the
  // UIInputText fields above this section.
  .WebsiteShareUserSection__label {
    @include font-body-small-bold;
    margin: 0;
    color: var(--text-primary);
  }
}
</style>
